module.exports = __webpack_public_path__ + "img/Add.97ec4afb.svg";